import { useMemo } from 'react';
import { CSSObjectWithLabel, StylesConfig } from 'react-select';

// Стили react-select на токенах темы: те же высота, рамка и скругление,
// что у полей antd, и цвета текущей палитры.
export const useStyles = (large?: boolean, error?: boolean): StylesConfig<any, boolean> =>
  useMemo(
    () => ({
      menuPortal: (css: CSSObjectWithLabel) => ({ ...css, zIndex: 9999 }),

      container: (css: CSSObjectWithLabel) => ({
        ...css,
        '.rs-option-icon, .rs-search-icon, .rs-searchable-option-icon': { lineHeight: 0 },
      }),

      control: (css, state) => ({
        ...css,
        minHeight: large ? 'var(--button-height-lg)' : 'var(--control-height)',
        padding: '0 12px 0 0',
        fontSize: 14,
        backgroundColor: state.isDisabled ? 'var(--color-surface-muted)' : 'var(--color-surface)',
        borderRadius: 'var(--radius)',
        borderColor: error
          ? 'var(--color-danger)'
          : state.isFocused
          ? 'var(--color-primary)'
          : 'var(--color-border)',
        boxShadow: state.isFocused ? 'var(--focus-ring)' : 'none',
        transition: 'border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
        cursor: 'pointer',

        '&:hover': {
          borderColor: error
            ? 'var(--color-danger)'
            : state.isFocused
            ? 'var(--color-primary)'
            : 'var(--color-border-input-hover)',
        },

        '.rs-search-icon': {
          display: state.menuIsOpen ? 'block' : 'none',
          transform: state.menuIsOpen ? 'rotate(180deg)' : 'rotate(0)',
          marginRight: '8px',
          color: 'var(--color-text-muted)',
        },

        '.rs-searchable-option-icon': {
          display: state.menuIsOpen ? 'none' : 'inherit',
        },
      }),

      placeholder: (css: CSSObjectWithLabel) => ({
        ...css,
        color: 'var(--color-text-placeholder)',
        fontSize: 14,
      }),

      singleValue: (css: CSSObjectWithLabel) => ({ ...css, color: 'var(--color-text)' }),

      multiValue: (css: CSSObjectWithLabel) => ({
        ...css,
        backgroundColor: 'var(--color-primary-soft)',
        borderRadius: 'var(--radius-sm)',
      }),

      multiValueLabel: (css: CSSObjectWithLabel) => ({
        ...css,
        color: 'var(--color-primary)',
        fontSize: 12,
        fontWeight: 700,
      }),

      multiValueRemove: (css: CSSObjectWithLabel) => ({
        ...css,
        color: 'var(--color-primary)',
        borderRadius: 'var(--radius-sm)',
        ':hover': { backgroundColor: 'var(--color-info-bg)', color: 'var(--color-primary-hover)' },
      }),

      indicatorSeparator: (css: CSSObjectWithLabel) => ({ ...css, display: 'none' }),

      dropdownIndicator: (css, state) => ({
        ...css,
        padding: 0,
        color: 'var(--color-text-muted)',
        svg: {
          transform: `rotate(${state.selectProps.menuIsOpen ? '180deg' : '0deg'})`,
          transition: 'transform 0.3s ease-out',
        },
      }),

      menu: (css, state) => ({
        ...css,
        marginTop: 4,
        marginBottom: 0,
        overflow: 'hidden',
        border: '1px solid var(--color-border)',
        borderRadius: 'var(--radius)',
        boxShadow: 'var(--shadow-md)',
        opacity: state.selectProps.menuIsOpen ? 1 : 0,
        zIndex: 2,
        transition: 'opacity 2s ease-out',
      }),

      option: (css, state) => ({
        ...css,
        fontSize: 14,
        cursor: 'pointer',
        color: state.isSelected ? 'var(--color-primary)' : 'var(--color-text)',
        fontWeight: state.isSelected ? 700 : 400,
        backgroundColor: state.isSelected
          ? 'var(--color-primary-soft)'
          : state.isFocused
          ? 'var(--color-fill)'
          : 'transparent',
        ':active': { backgroundColor: 'var(--color-primary-soft)' },
      }),
    }),
    [large, error],
  );
